import pay from "./pay";
import download from "./download";
export default {
  pay,
  download,
};
